import { Component } from '@angular/core';
import { LiveAgentSupportService } from './live-agent-support.service';

@Component({
    selector: 'lp2-live-agent-support',
    templateUrl: './live-agent-support.component.html',
    styleUrls: ['./live-agent-support.component.scss']
})
export class LiveAgentSupportComponent {
    constructor(private liveAgentService: LiveAgentSupportService) {}

    enterLiveChat() {
        this.liveAgentService.startChat();    
    }
}



// WEBPACK FOOTER //
// ./ts/app/header/live-agent-support/live-agent-support.component.ts